import { render, staticRenderFns } from "./DirectionHorizontalIcon.vue?vue&type=template&id=024684a2&"
import script from "./DirectionHorizontalIcon.vue?vue&type=script&lang=js&"
export * from "./DirectionHorizontalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports